import api from "./api";
import APIError from "../models/ApiError";

export const getGeoservices = async (params) => {
  try {
    const response = await api.get("/geoservices", { params });

    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const getGcbaGeoservices = async (params) => {
  try {
    const response = await api.get("/geoservices", {
      params: { ...params, geoservice_type_id: 1 },
    });
    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const getExternalGeoservices = async (params) => {
  try {
    const response = await api.get("/geoservices", {
      params: { ...params, geoservice_type_id: 2 },
    });
    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const createGeoservice = async (data) => {
  try {
    const response = await api.post("/geoservices/", data);

    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const updateGeoservice = async (id, data) => {
  try {
    const response = await api.put(`/geoservices/${id}`, data);

    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const deleteGeoservice = async (id) => {
  try {
    const response = await api.put(`/geoservices/${id}/deactivate`);
    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};

export const getGeoservice = async (id) => {
  try {
    const response = await api.get(`/geoservices/${id}`);
    return response.data;
  } catch (error) {
    if (error.isAxiosError) {
      throw new APIError(
        error.response?.status || 500,
        error.response?.data?.message,
      );
    }
    throw error;
  }
};
